import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RCore from 'RCore';
import { connect } from 'react-redux';
import { loadDictionary } from '../actions';
import CommonI18Table from './CommonI18Table';
import SelectSecondaryLang from './SelectSecondaryLang';
import SaveBtn from './SaveBtn';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import IconCommonI18Dashboard from 'material-ui/svg-icons/action/language';
import { indigo500, grey300 } from 'material-ui/styles/colors';

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const HeaderLeft = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`;

const Title = styled.h2`
    color: ${indigo500};
    font-weight: inherit;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const BtnWrapper = styled.div`
    margin-top: 16px;
`;

const CardHeaderStyle = {
    borderBottom: `1px solid ${grey300}`,
    paddingTop: 0,
    paddingBottom: 0,
};

const IconTitleStyle = {
    color: 'inherit',
};

const CardStyle = {
    marginBottom: 15,
};

class CommonI18DashboardIndex extends PureComponent {
    componentDidMount() {
        this.props.loadDictionary(
            RCore.i18Register(require('../../../../widgets/i18/default/i18.Common'), { en: {} }).en,
        );
    }

    render() {
        return (
            <Card style={CardStyle}>
                <CardHeader style={CardHeaderStyle}>
                    <HeaderWrapper>
                        <HeaderLeft>
                            <Title>
                                <IconCommonI18Dashboard style={IconTitleStyle} />
                                Common I18n Dashboard
                            </Title>
                        </HeaderLeft>
                        <SelectSecondaryLang />
                        <SaveBtn />
                    </HeaderWrapper>
                </CardHeader>
                <CardText>
                    <CommonI18Table />
                    <BtnWrapper>
                        <SaveBtn />
                    </BtnWrapper>
                </CardText>
            </Card>
        );
    }
}

CommonI18DashboardIndex.propTypes = {
    // From connect
    loadDictionary: PropTypes.func.isRequired,
};

export default connect(
    null,
    { loadDictionary },
)(CommonI18DashboardIndex);



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/components/CommonI18DashboardIndex.js
 **/